import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.component.html',
  styleUrls: ['./notifications-page.component.sass']
})
export class NotificationsPageComponent implements OnInit {

  accountCategory: string = '';

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.accountCategory = this.apiService.accountDetail.category;
  }

}
